import type { CybertubeProgress, MovieSummary, WatchProgress } from './types';

/**
 * CyberTube resume points are keyed by YouTube video id, while the movie rails
 * speak in MovieSummary/WatchProgress. These adapters let both appear on the
 * one "continue watching" row without giving CyberTube a fake movie identity.
 */

export function cybertubeProgressMovie(item: CybertubeProgress): MovieSummary {
  return {
    id: `cybertube:${item.sourceId}`,
    slug: null,
    title: item.title,
    description: item.channelTitle,
    year: null,
    poster: item.thumbnail,
    backdrop: item.thumbnail,
    durationSec: item.duration,
    runtime: item.duration / 60,
    video: null,
    availability: {
      status: 'ready', label: 'Ready', progress: 100, playbackReady: true,
      availableAt: null, availableInSec: null,
    },
    playback: null,
    href: '',
  };
}

export function cybertubeWatchProgress(item: CybertubeProgress): WatchProgress {
  return {
    movieId: `cybertube:${item.sourceId}`,
    currentTime: item.currentTime,
    duration: item.duration,
    updatedAt: item.updatedAt,
    completed: item.completed,
  };
}
